import range from 'lodash/range';
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import cn from 'classnames';
import { Ghost } from '@y2/mango/components/ghost';
import styles from './desktop-table.module.scss';
import { columns } from './desktop-table';

type Props = {
  size: number;
  className?: string;
};

export function DesktopTableSkeleton({ size, className }: Props) {
  const table = useReactTable({
    data: [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <table className={cn(styles.table, className)}>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id}>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext(),
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {range(size).map((index) => (
          <tr key={index}>
            {range(columns.length).map((index) => (
              <td key={index}>
                <Ghost />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
